<template>
	<div class="question">
		<div class="question__header"><p>{{header}}</p></div>
		<img :src="baseUrl + visual" class="question__visual"/>
		<div class="question__text">
			<p>{{text}}</p>
		</div>
	</div>
</template>

<script>

	import {url} from '../../../const/base';
	import {mapGetters , mapActions} from 'vuex';

	export default {

		props:[
			'header',
			'visual',
			'text'
		],
		mounted(){},
		data(){
			return {
				baseUrl : url,
			}
		},
		methods:{
			...mapActions([]),
		},
		computed:{
			...mapGetters([]),
		},

	}
</script>


// WEBPACK FOOTER //
// src/components/minigames/swipequiz/Question.vue